// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G07IXB {
  display: grid;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  box-sizing: border-box;
  background-color: var(--public-layout-background-color);
  gap: var(--current-grid-gutter, 16px);
  padding: var(--current-grid-gutter, 16px);

  /* Mobile: 1 column (320px ~ 599px) */
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'hero'
    'content';
}

/* Tablet: 2 columns with optimized proportions (600px ~ 1023px) */
@media (min-width: 600px) {
  .G07IXB {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'hero content';
    padding: 8px;
    gap: 0;

    /* Small tablets adjusts proportion */
    grid-template-columns: 45% 55%;
  }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
  .G07IXB {
    grid-template-columns: 1fr 1fr;
  }
}

.h895ve {
  grid-area: hero;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--public-layout-background-color);

  /* Mobile (320px ~ 599px) */
  min-height: 200px;
}

/* Tablet and Desktop (600px+) */
@media (min-width: 600px) {
  .h895ve {
    min-height: 100%;
    max-height: 100%;
  }
}

.Q4PIOp {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: var(--radius-s);
}

.LyuSRH {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-s);
}

.DcFbzJ {
  position: absolute;
  bottom: 32px;
  left: 32px;
  width: 120px;
  height: 40px;
  z-index: 2;
}

.oX9dO2 {
  grid-area: content;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--public-layout-background-color);
  border-radius: var(--radius-s);
  position: relative;
  padding: var(--spacing-3, 24px);
}

.eyGFvi {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-s);
  z-index: 0;
  filter: brightness(0) saturate(100%) invert(99%) sepia(6%) saturate(7%) hue-rotate(256deg) brightness(114%)
    contrast(90%) opacity(var(--public-layout-opacity));
}

.CnMf3o {
  width: 100%;
  max-width: calc(
    var(--current-grid-columns, 12) * 60px + var(--current-grid-gutter, 24px) * (var(--current-grid-columns, 12) - 1)
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
  gap: var(--spacing-3, 24px);
}

.C1k7Uq {
  width: 100%;
  max-width: 340px;
  height: auto;
  object-fit: contain;
}

.JHhPj6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  width: 100%;
  padding: 0 var(--spacing-3);
  max-width: calc(
    var(--current-grid-columns, 4) * 80px + var(--current-grid-gutter, 16px) * (var(--current-grid-columns, 4) - 1)
  );
}

.ejaDh2 {
  font-family: 'Source Sans 3', sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 180% !important;
  text-decoration: underline !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 2px !important;
  text-decoration-color: currentColor !important;
  text-decoration-skip-ink: none !important;
  color: var(--public-layout-text-color) !important;
}

.C80KN7 {
  font-family: 'Source Sans 3', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 180%;
  opacity: 0.3;
  display: inline-block;
  margin: 0 8px;
  color: var(--public-layout-separator-color) !important;
}

@media (max-width: 599px) {
  .JHhPj6 {
    max-width: 100%;
  }

  .ejaDh2 {
    font-size: 12px !important;
    white-space: nowrap;
  }

  .C80KN7 {
    margin: 0 4px;
    font-size: 12px;
  }
}

@media (min-width: 600px) and (max-width: 1023px) {
  .JHhPj6 {
    max-width: 380px;
  }
}

@media (min-width: 1024px) {
  .JHhPj6 {
    max-width: 440px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/PublicLayout/PublicLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uDAAuD;EACvD,qCAAqC;EACrC,yCAAyC;;EAEzC,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B;;aAEW;AACb;;AAEA,kEAAkE;AAClE;EACE;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,mCAAmC;IACnC,YAAY;IACZ,MAAM;;IAEN,qCAAqC;IACrC,8BAA8B;EAChC;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;;EAEvD,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,UAAU;EACV;uDACqD;AACvD;;AAEA;EACE,WAAW;EACX;;GAEC;EACD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,MAAM;EACN,WAAW;EACX,2BAA2B;EAC3B;;GAEC;AACH;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,qCAAqC;EACrC,yCAAyC;EACzC,qCAAqC;EACrC,8CAA8C;EAC9C,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".publicLayout {\n  display: grid;\n  width: 100vw;\n  height: 100vh;\n  max-height: 100vh;\n  box-sizing: border-box;\n  background-color: var(--public-layout-background-color);\n  gap: var(--current-grid-gutter, 16px);\n  padding: var(--current-grid-gutter, 16px);\n\n  /* Mobile: 1 column (320px ~ 599px) */\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr;\n  grid-template-areas:\n    'hero'\n    'content';\n}\n\n/* Tablet: 2 columns with optimized proportions (600px ~ 1023px) */\n@media (min-width: 600px) {\n  .publicLayout {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    grid-template-areas: 'hero content';\n    padding: 8px;\n    gap: 0;\n\n    /* Small tablets adjusts proportion */\n    grid-template-columns: 45% 55%;\n  }\n}\n\n/* Desktop (1024px+) */\n@media (min-width: 1024px) {\n  .publicLayout {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.publicLayoutLeft {\n  grid-area: hero;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--public-layout-background-color);\n\n  /* Mobile (320px ~ 599px) */\n  min-height: 200px;\n}\n\n/* Tablet and Desktop (600px+) */\n@media (min-width: 600px) {\n  .publicLayoutLeft {\n    min-height: 100%;\n    max-height: 100%;\n  }\n}\n\n.publicLayoutLeftImageContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: var(--radius-s);\n}\n\n.publicLayoutLeftImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--radius-s);\n}\n\n.publicLayoutLeftBottomImage {\n  position: absolute;\n  bottom: 32px;\n  left: 32px;\n  width: 120px;\n  height: 40px;\n  z-index: 2;\n}\n\n.publicLayoutRight {\n  grid-area: content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--public-layout-background-color);\n  border-radius: var(--radius-s);\n  position: relative;\n  padding: var(--spacing-3, 24px);\n}\n\n.publicLayoutRightBackground {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: var(--radius-s);\n  z-index: 0;\n  filter: brightness(0) saturate(100%) invert(99%) sepia(6%) saturate(7%) hue-rotate(256deg) brightness(114%)\n    contrast(90%) opacity(var(--public-layout-opacity));\n}\n\n.publicLayoutContent {\n  width: 100%;\n  max-width: calc(\n    var(--current-grid-columns, 12) * 60px + var(--current-grid-gutter, 24px) * (var(--current-grid-columns, 12) - 1)\n  );\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n  gap: var(--spacing-3, 24px);\n}\n\n.publicLayoutLogo {\n  width: 100%;\n  max-width: 340px;\n  height: auto;\n  object-fit: contain;\n}\n\n.loginFooterGlobal {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0;\n  width: 100%;\n  padding: 0 var(--spacing-3);\n  max-width: calc(\n    var(--current-grid-columns, 4) * 80px + var(--current-grid-gutter, 16px) * (var(--current-grid-columns, 4) - 1)\n  );\n}\n\n.loginFooterLink {\n  font-family: 'Source Sans 3', sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 14px !important;\n  line-height: 180% !important;\n  text-decoration: underline !important;\n  text-decoration-thickness: 1px !important;\n  text-underline-offset: 2px !important;\n  text-decoration-color: currentColor !important;\n  text-decoration-skip-ink: none !important;\n  color: var(--public-layout-text-color) !important;\n}\n\n.loginFooterSeparator {\n  font-family: 'Source Sans 3', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 180%;\n  opacity: 0.3;\n  display: inline-block;\n  margin: 0 8px;\n  color: var(--public-layout-separator-color) !important;\n}\n\n@media (max-width: 599px) {\n  .loginFooterGlobal {\n    max-width: 100%;\n  }\n\n  .loginFooterLink {\n    font-size: 12px !important;\n    white-space: nowrap;\n  }\n\n  .loginFooterSeparator {\n    margin: 0 4px;\n    font-size: 12px;\n  }\n}\n\n@media (min-width: 600px) and (max-width: 1023px) {\n  .loginFooterGlobal {\n    max-width: 380px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .loginFooterGlobal {\n    max-width: 440px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publicLayout": `G07IXB`,
	"publicLayoutLeft": `h895ve`,
	"publicLayoutLeftImageContainer": `Q4PIOp`,
	"publicLayoutLeftImage": `LyuSRH`,
	"publicLayoutLeftBottomImage": `DcFbzJ`,
	"publicLayoutRight": `oX9dO2`,
	"publicLayoutRightBackground": `eyGFvi`,
	"publicLayoutContent": `CnMf3o`,
	"publicLayoutLogo": `C1k7Uq`,
	"loginFooterGlobal": `JHhPj6`,
	"loginFooterLink": `ejaDh2`,
	"loginFooterSeparator": `C80KN7`
};
module.exports = ___CSS_LOADER_EXPORT___;
